import { Audit, Auditable, Dictionary, Dto, IDName } from '@damofire/data-commons';
import { Timestamp } from 'firebase/firestore';
import { EmbeddedAsset } from '../asset/asset.dto';
import { Description } from '../des.dto';
import { Noteable } from '../note/note.dto';

export interface IssueCfg extends Auditable {
  actions?: string[];
  components?: Dictionary<string[]>;
  defaults?: Dictionary<string>;
  descriptions?: string[];
  localized?: Dictionary<string>;
  colors?: Dictionary<string>;
  mysqlIds?: Dictionary<number>;
  organizationId?: string;
  priorities?: string[];
  resolutions?: Dictionary<string>;
  statuses?: string[];
  weightedPriorities?: Dictionary<number>;
}

export interface AssetTypeCfg extends Auditable {
  assetType?: Description<number>;
  description?: string;
  components?: string[];
  componentTree?: string[];
  localized?: Dictionary<string>;
  colors?: Dictionary<string>;
  mysqlIds?: Dictionary<number>;
  organizationId?: string;
}

export interface IssueMedia extends Dto<string> {
  division?: { _id?: string };
  organization?: { _id?: string };
  issue?: { _id?: string };
  filename?: string;
  original?: string;
  thumb?: string;
  web?: string;
  size?: number;
  annotations?: any[];
}

export interface IdbIssueMedia extends IssueMedia {
  bytes?: string;
  bytesPath?: string;
  thumbBytes?: string;
  thumbBytesPath?: string;
  format?: string;
}

export interface RiskLevel extends Description<number> {
  weight?: number;
}

export interface LocalizedRiskLevel extends Description<number> {
  weight?: number;
  color?: string;
}

export type IssueComponent = Description<number>;

export interface LocalizedIssueComponent extends Description<number> {
  color?: string;
}

export enum IssueUserType {
  ENG = 'ENG',
  REP = 'REP',
  USER = 'USER',
}

export interface IssueAudit extends Audit {
  createdByType?: IssueUserType;
  lastModifiedByType?: IssueUserType;
}

export interface Issue extends Noteable {
  audit?: IssueAudit;
  warehouseIssueId?: number;
  action?: Description<number>;
  asset?: EmbeddedAsset;
  component?: Description<number>;
  description?: Description<number>;
  equipment?: string;
  depth?: string;
  inspection?: IDName<number>;
  issueId?: number;
  issue?: string;
  repair?: {
    by: string;
    date: Date | Timestamp;
    _id?: string;
  };
  resolution?: Resolution;
  riskLevel?: RiskLevel;
  status?: Description<number>;
  reviewDate?: Date | Timestamp;
  coordinates?: {
    x?: number;
    y?: number;
    sideView?: boolean;
  };
}

export interface EmbeddedIssue {
  _id?: string;
  descriptionEn?: string;
  descriptionFr?: string;
  warehouseIssueId?: number;
}

export const ACTIVES_RESOLUTION_ID = 999;
export enum Resolution {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
}

export interface IssuesTimeline {
  created: Dictionary<number>;
  repaired: Dictionary<number>;
}

export const IMAGE_NOT_AVAILABLE = 'IMAGE_NOT_AVAILABLE';
export const IMAGE_NOT_FOUND = 'IMAGE_NOT_FOUND';
